<template>
    <div class="backBox">
        <div style="padding:10px 15px">
            <div class="tab-box">
                <div :class="tabNum===1?'tab-active':''" @click="tabNum=1">{{$t("equipmentPair.gatewayController")}}</div>
                <div :class="tabNum===2?'tab-active':''" @click="tabNum=2">{{$t("equipmentPair.clientDevice")}}</div>
            </div>

            <!--网关tab-->
            <div v-if="tabNum===1">
                <div class="search-box">
                    <form action="/">
                        <van-search v-model="searchValue" shape="round" class="equ-search" :placeholder="$t('equipmentPair.searchTitle')" @search="onSearch"/>
                    </form>
                    <div class="filter" @click="netEquSheet=true">
                        <span>{{netEquText}}</span> <img src="../../assets/equipment-pair/filter.png">
                    </div>
                </div>
                <div class="shadowBox">
                    <div @click="openSnInput">
                        <img src="../../assets/equipment-pair/edit-round.png" style="width: 7.8vh">&nbsp;
                        {{$t("equipmentPair.enterSN")}}
                    </div>
                    <div @click="scanEqu">
                        <img src="../../assets/equipment-pair/scan-round.png" style="width: 7.8vh">&nbsp;
                        {{$t("equipmentPair.scaleQRCode")}}
                    </div>
                </div>
                <div class="part-title">
                    <div class="left-filter">
                        <div :class="filterType==='gmtModified'?'time-filter active':'time-filter'" @click="filterChange('gmtModified')">
                            {{$t("equipmentPair.deviceDate")}}
                            <div v-if="filterType==='gmtModified'">
                                <img v-if="timeSort" src="../../assets/equipment-pair/asc.png">
                                <img v-else src="../../assets/equipment-pair/desc.png">
                            </div>
                            <div v-else><img src="../../assets/equipment-pair/dis-filter.png"></div>
                        </div>
                        <div :class="filterType==='remark'?'name-filter active':'name-filter'" @click="filterChange('remark')">
                            {{$t("equipmentPair.deviceName")}}
                            <div v-if="filterType==='remark'">
                                <img v-if="nameSort" src="../../assets/equipment-pair/asc.png">
                                <img v-else src="../../assets/equipment-pair/desc.png">
                            </div>
                            <div v-else><img src="../../assets/equipment-pair/dis-filter.png"></div>
                        </div>
                    </div>
                    <div v-if="netCheck" @click="cancelCheck">{{$t('equipmentPair.cancel')}}</div>
                    <div v-else @click="checkEqu">{{$t('equipmentPair.edit')}}</div>
                </div>
                <div class="equ-list">
                    <van-checkbox-group v-model="checkResult">
                        <van-list v-model="nLoading" :finished="nFinished" :finished-text="$t('default.noMore')" @load="onLoadNetEqu">
                            <div class="equ-one" v-for="(item,index) in equList" :key="index" @click="lookDetail(item.deviceId)">
                                <div class="mask white-m" v-show="mask"></div>
                                <van-checkbox :name="item" v-show="mask" class="check"></van-checkbox>
                                <div class="one">
                                    <img :src="item.imgPath?item.imgPath:localPhoto" :onerror = "defaultPhoto"  class="img-list" style="border-radius: 4px">
                                    <div class="one-info">
                                        <div class="two1">
                                            <div>{{item.remark}}</div>
<!--                                            <signal :num="item.getSignalFlag" class="signal"></signal>-->
                                        </div>
                                        <div class="two2">SN：{{item.deviceId}}</div>
                                    </div>
                                </div>
                                <div class="two">
                                    <span class="blue">{{item.childCount}}</span>
                                    <span class="gray"><span style="margin: 0 2px">/</span>{{item.maxChild}}</span>
                                </div>
                            </div>
                        </van-list>
                    </van-checkbox-group>
                </div>
            </div>

            <!--终端tab-->
            <div v-if="tabNum===2">
                <div class="search-box">
                    <form action="/">
                        <van-search v-model="searchTerValue" shape="round" class="equ-search" :placeholder="$t('equipmentPair.searchTitle')" @search="onSearch"/>
                    </form>
                    <div class="filter" @click="terEquSheet=true">
                        <span>{{terEquText}}</span> <img src="../../assets/equipment-pair/filter.png">
                    </div>
                </div>
                <div class="shadowBox">
                    <div @click="openSnInput">
                        <img src="../../assets/equipment-pair/edit-round.png" style="width: 7.8vh">&nbsp;
                        {{$t("equipmentPair.enterSN")}}
                    </div>
                    <div @click="scanEqu">
                        <img src="../../assets/equipment-pair/scan-round.png" style="width: 7.8vh">&nbsp;
                        {{$t("equipmentPair.scaleQRCode")}}
                    </div>
                </div>
                <div class="part-title">
                    <div class="left-filter">
                        <div :class="tFilterType==='gmtModified'?'time-filter active':'time-filter'" @click="filterChange('gmtModified')">
                            {{$t("equipmentPair.deviceDate")}}
                            <div v-if="tFilterType==='gmtModified'">
                                <img v-if="tTimeSort" src="../../assets/equipment-pair/asc.png">
                                <img v-else src="../../assets/equipment-pair/desc.png">
                            </div>
                            <div v-else><img src="../../assets/equipment-pair/dis-filter.png"></div>
                        </div>
                        <div :class="tFilterType==='remark'?'name-filter active':'name-filter'" @click="filterChange('remark')">
                            {{$t("equipmentPair.deviceName")}}
                            <div v-if="tFilterType==='remark'">
                                <img v-if="tNameSort" src="../../assets/equipment-pair/asc.png">
                                <img v-else src="../../assets/equipment-pair/desc.png">
                            </div>
                            <div v-else><img src="../../assets/equipment-pair/dis-filter.png"></div>
                        </div>
                    </div>
                    <div v-if="terCheck" @click="cancelCheck">{{$t('equipmentPair.cancel')}}</div>
                    <div v-else @click="checkEqu">{{$t('equipmentPair.edit')}}</div>
                </div>
            </div>
        </div>
        <div v-if="tabNum===2" class="equ-list">
            <van-checkbox-group v-model="checkTResult">
                <van-list v-model="terLoading" :finished="terFinished" :finished-text="$t('default.noMore')" @load="onLoadTerEqu">
                    <div v-for="(item,index) in terminalList" :key="index" class="equ-one-bottom">
                        <div class="mask white-m-half" v-show="item.status===6"></div>
                        <div class="mask white-m" v-show="tMask&&item.status!=6"></div>
                        <van-checkbox :name="item" v-show="tMask&&item.status!=6" class="check" style="right: 20px;"></van-checkbox>
                        <div :class="item.status===3?'equ-one red-back':'equ-one'" style="padding: 15px">
                            <div class="one">
                                <img :src="item.imgPath?item.imgPath:localPhoto" :onerror = "defaultPhoto" class="img-list" style="border-radius: 4px">
                                <div class="one-info">
                                    <div class="two1">
                                        {{item.remark}}
                                        &nbsp;&nbsp;<img src="../../assets/equipment-pair/edit.png" @click="editTerName(item.remark,item.deviceId)">
                                    </div>
                                    <div class="two2">SN：{{item.deviceId}}</div>
                                </div>
                            </div>
                            <div class="two">
                                <div v-if="item.status===1" class="pair disPair"><img src="../../assets/equipment-pair/dis-pair.png">&nbsp;{{$t('equipmentPair.statusNoPaired')}}</div>
                                <div v-if="item.status===2" class="pair pairing">&nbsp;{{$t('equipmentPair.statusWaitingToPair')}}</div>
                                <div v-if="item.status===3" class="pair pairing"><img src="../../assets/equipment-pair/pair-process.gif">&nbsp;{{$t('equipmentPair.statusPairing')}}</div>
                                <div v-if="item.status===4" class="pair off-pair"><img src="../../assets/equipment-pair/off-pair.png">&nbsp;{{$t('equipmentPair.statusPairFailed')}}</div>
                                <div v-if="item.status===5" class="pair paired"><img src="../../assets/equipment-pair/pair-success.gif">&nbsp;{{$t('equipmentPair.statusPairSuccessed')}}</div>
                                <div v-if="item.status===6" class="pair pairing"><img src="../../assets/equipment-pair/bind.png">&nbsp;{{$t('equipmentPair.statusBinded')}}</div>
                            </div>
                            <div v-if="item.status===6" class="bind-text">
                                {{$t('equipmentPair.deviceBindedNoAllowedToOperate')}}
                            </div>
                        </div>
                        <transition name="fade">
                            <div v-if="item.status===3" class="pairing-text">
                                {{$t('equipmentPair.devicePairingTip')}}
                            </div>
                        </transition>
                    </div>

                </van-list>
            </van-checkbox-group>
        </div>
        <div v-if="netCheck&&tabNum===1" class="fixBottom bottom-btn">
            <van-button v-if="checkResult.length>0" color="#286EFF" round class="net" @click="delConfirm=true">{{$t('equipmentPair.delete')}}</van-button>
            <van-button v-else color="#DADADA" round class="net">{{$t('equipmentPair.delete')}}</van-button>

            <van-button type="info" round plain class="net" @click="cancelCheck">{{$t('equipmentPair.cancel')}}</van-button>
        </div>

        <div v-if="terCheck&&tabNum===2" class="fixBottom bottom-btn">
            <van-button v-if="checkTResult.length>0" color="#286EFF" round class="terminal" @click="terDelConfirm=true">{{$t('equipmentPair.delete')}}</van-button>
            <van-button v-else color="#DADADA" round class="terminal">{{$t('equipmentPair.delete')}}</van-button>
            <van-button type="info" round plain class="terminal" @click="cancelCheck">{{$t('equipmentPair.cancel')}}</van-button>
        </div>

        <!-- 主设备删除提示-->
        <van-dialog
                v-model="delConfirm"
                :title="$t('equipmentPair.deleteGatewayControllerPromptTitle')"
                show-cancel-button
                cancel-button-color="#999999"
                class="self-dialog"
                @confirm="delNetEqu"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
            <template slot="default">
                <div class="confirm-content">
                    <div class="small-red">{{$t('equipmentPair.deleteGatewayControllerPromptTip')}}</div>
                </div>
            </template>
        </van-dialog>

        <!-- 终端设备删除提示-->
        <van-dialog
                v-model="terDelConfirm"
                :title="$t('equipmentPair.deleteClientPromptTitle')"
                show-cancel-button
                cancel-button-color="#999999"
                class="self-dialog"
                @confirm="delTerChild"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
        </van-dialog>

        <!-- 输入SN码-->
        <div class="dialog-mask" v-show="snConfirm">
            <div class="dialog" ref="SN">
                <div class="content">
                    <div class="title">{{$t('equipmentPair.enterDeviceInfo')}}</div>
                    <img src="../../assets/equipment-pair/QRCode.png" class="qrCode">
                    <van-field
                            v-model="deviceId"
                            class="move-input"
                            :placeholder="$t('equipmentPair.tipEnterSN')"
                            @focus="snInputVal"
                            @blur="inputLeave"
                    />
                    <van-field
                            v-model="serialCode"
                            class="move-input"
                            :placeholder="$t('equipmentPair.tipEnter4PlaceSecurityCode')"
                            @focus="codeInputVal"
                            @blur="inputLeave"
                    />
                </div>
                <div class="footer">
                    <div class="cancel-btn" @click="closeSnInput">{{$t('equipmentPair.cancel')}}</div>
                    <div class="sure-btn" @click="addEqu">{{$t('equipmentPair.confirm')}}</div>
                </div>
            </div>
        </div>

        <!--编辑终端设备名称-->
        <van-dialog
                v-model="terNameConfirm"
                :title="$t('equipmentPair.clientNameTitle')"
                show-cancel-button
                cancel-button-color="#999999"
                class="self-dialog"
                :before-close="terNameBeforeClose"
                :confirm-button-text="$t('equipmentPair.confirm')"
                :cancel-button-text="$t('equipmentPair.cancel')"
        >
            <template slot="default">
                <div class="confirm-content">
                    <van-field
                            v-model="terName"
                            class="move-input"
                            @input="filterEmoji"
                            :placeholder="$t('equipmentPair.tipEnterClientName')"
                    />
                </div>
            </template>
        </van-dialog>

        <van-action-sheet
                round
                v-model="netEquSheet"
                :actions="netEquList"
                @select="netEquSelect"
        />

        <van-action-sheet
                round
                v-model="terEquSheet"
                :actions="terEquList"
                @select="terminalEquSelect"
        />
    </div>
</template>

<script>
import { Search ,Checkbox, CheckboxGroup ,Button ,Dialog, Field ,ActionSheet ,List ,Toast } from 'vant';
import Signal from "@/components/Signal";
import { netEqu,terminalEqu } from "@/util/equipment-pair";
import { scanQRCode ,showRightTop ,showNavigationRightMoreButton ,getAppVersion ,goTo ,inputCompress ,inputCover} from "@/util/jsbridge";
import api from "@/api/equipment-pair";
import compareVersion from "@/util/formatVersion";
import filterEmoji from "@/util/filterEmoji";

export default {
    name: "Home",
    components:{
        [Search.name]:Search,
        [Checkbox.name]:Checkbox,
        [CheckboxGroup.name]:CheckboxGroup,
        [Button.name]:Button,
        [Dialog.Component.name]: Dialog.Component,
        [Field.name]:Field,
        [Signal.name]:Signal,
        [ActionSheet.name]:ActionSheet,
        [List.name]:List,
    },
    data(){
      return{
          tabNum:1,
          searchValue:"",
          searchTerValue:"",
          mask:false,
          tMask:false,
          netCheck:false,
          terCheck:false,
          checkResult:[],
          checkTResult:[],
          netEquSheet:false,
          terEquSheet:false,
          netEquList:[],
          terEquList:[],
          netEquText:"",
          terEquText:"",
          nLoading: false,
          nFinished: false,
          terLoading:false,
          terFinished:false,
          localPhoto:require("../../assets/equipment-pair/default-photo.jpg"),
          defaultPhoto:'this.src="' + require('../../assets/equipment-pair/default-photo.jpg') + '"',
          equList:[],
          terminalList:[],
          delConfirm:false,
          terDelConfirm:false,
          snConfirm:false,
          deviceId:null,
          serialCode:null,
          page:0,
          tPage:0,
          pageSize:5,
          type:"",
          tType:"",
          terNameConfirm:false,
          terName:"",
          terDeviceId:"",
          filterType:"gmtModified",
          timeSort:true,
          nameSort:false,
          tFilterType:"gmtModified",
          tTimeSort:true,
          tNameSort:false,
      }
    },
    created(){
        getAppVersion(this.showAppVersion);
        this.netEquList=netEqu();
        this.netEquText=this.netEquList[0].name;
        this.terEquList=terminalEqu();
        this.terEquText=this.terEquList[0].name;
    },
    mounted() {
        window.getScanningQRCode = this.getScanningQRCode;
        window.navigationRightMoreButtonClicked=this.navigationRightMoreButtonClicked;
    },
    methods:{
        showAppVersion(version){
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let deviceWifiTitale = this.$t('titles.deviceWifi')
            if (isiOS) {
                if(compareVersion(version,"3.2.2")){  //3.2.2 (包含)后新版可以用js方法弹右上角窗
                    showNavigationRightMoreButton(true,deviceWifiTitale);
                }else {   //3.2.2老版只能用路径跳转的方式弹
                    showRightTop("[{url:'', text:'"+this.$t("default.newVersionNotice")+"'}]", this.$t("default.newVersionNotice"));
                }
            } else {
                if(compareVersion(version,"3.1.7")){  //3.1.7 (包含)后新版可以用js方法弹右上角窗
                    showNavigationRightMoreButton(true,deviceWifiTitale);
                }else {   //3.1.7老版本只能用路径跳转的方式弹
                    showRightTop("[{url:'', text:'"+this.$t("default.newVersionNotice")+"'}]", this.$t("default.newVersionNotice"));
                }
            }
        },
        navigationRightMoreButtonClicked(){
            goTo("https://app.robooot.com/wifi/WifiConfigActivity",'','','');
        },
        onLoadNetEqu(){
            let params={
                page:++this.page,
                pageSize:this.pageSize,
                type:this.type,
                deviceId:this.searchValue,
                orderBy:this.filterType,
            };
            if(this.filterType==='gmtModified'){
                params['desc']=this.timeSort
            }else {
                params['desc']=this.nameSort
            }
            api.mainEquList(params).then(res=>{
                console.log("res 123:",res);

                if(res.result==0){
                    let self=this;
                    self.nLoading=false;
                    if(res.data.result.length>0){
                        try {
                            res.data.result.forEach(function (n) {
                                self.equList.push(n);
                                if(self.equList.length<res.data.total){
                                    self.nFinished = false;
                                }else {
                                    throw "";
                                }
                            });
                        }catch (e) {
                            self.nFinished=true;
                        }
                    }else {
                        self.nFinished=true;
                    }
                }else {
                    Toast(res.message);
                }
            })
        },
        onLoadTerEqu(){
            let params={
                status:"",
                page:++this.tPage,
                pageSize:this.pageSize,
                type:this.tType,
                deviceId:this.searchTerValue,
                orderBy:this.tFilterType,
            };
            if(this.tFilterType==='gmtModified'){
                params['desc']=this.tTimeSort
            }else {
                params['desc']=this.tNameSort
            }
            api.getChildEquList(params).then(res=>{
                if(res.result==0){
                    let self=this;
                    self.terLoading=false;
                    if(res.data.result.length>0){
                        try {
                            res.data.result.forEach(function (n) {
                                self.terminalList.push(n);
                                if(self.terminalList.length<res.data.total){
                                    self.terFinished = false;
                                }else {
                                    throw "";
                                }
                            });
                        }catch (e) {
                            self.terFinished=true;
                        }
                    }else {
                        self.terFinished=true;
                    }
                }else {
                    Toast(res.message);
                }
            })
        },
        onSearch(){
            if(this.tabNum===1){
                this.equList=[];
                this.page=0;
                this.onLoadNetEqu();
            }else {
                this.terminalList=[];
                this.tPage=0;
                this.onLoadTerEqu();
            }
        },
        checkEqu(){
            if(this.tabNum===1){
                this.netCheck=true;
                this.mask=true;
            }else {
                this.terCheck=true;
                this.tMask=true;
            }
        },
        cancelCheck(){
            if(this.tabNum===1){
                this.netCheck=false;
                this.mask=false;
                this.checkResult=[];
            }else {
                this.terCheck=false;
                this.tMask=false;
                this.checkTResult=[];
            }
        },
        lookDetail(id){
            if(this.mask==false){
                this.$router.push({name:"EquipmentDetails" ,query:{id:id}});
            }
        },

        snInputVal(){
            this.$refs.SN.style.bottom=16+'%';
        },
        codeInputVal(){
            this.$refs.SN.style.bottom=15+'%';
        },
        inputLeave(){
            window.scrollTo(0,0);
            this.$refs.SN.style.bottom=30+'%';
        },

        filterEmoji(value){
            this.terName=filterEmoji(value)
        },

        netEquSelect(val){
            this.netEquText=val.name;
            this.type=val.en;
            this.netEquSheet=false;
            this.equList=[];
            this.page=0;
            this.onLoadNetEqu();
        },
        terminalEquSelect(val){
            this.terEquText=val.name;
            this.tType=val.en;
            this.terEquSheet=false;
            this.terminalList=[];
            this.tPage=0;
            this.onLoadTerEqu();
        },

        filterChange(type){
            if(this.tabNum===1){
                this.filterType=type;
                this.equList=[];
                this.page=0;
                if(type==='gmtModified'){
                    this.timeSort=!this.timeSort;
                }else {
                    this.nameSort=!this.nameSort;
                }
                this.onLoadNetEqu();
            }else {
                this.tFilterType=type;
                this.terminalList=[];
                this.tPage=0;
                if(type==='gmtModified'){
                    this.tTimeSort=!this.tTimeSort;
                }else {
                    this.tNameSort=!this.tNameSort;
                }
                this.onLoadTerEqu();
            }
        },

        openSnInput(){
            this.snConfirm=true;
            inputCompress();
        },

        closeSnInput(){
            this.snConfirm=false;
            inputCover();
        },

        //输入sn添加设备
        addEqu(){
            if(!this.deviceId||this.deviceId===""){
                Toast(this.$t('equipmentPair.tipEnterSN'));
                return;
            }
            if(!this.serialCode||this.serialCode===""){
                Toast(this.$t('equipmentPair.tipEnterSecurityCode'));
                return;
            }
            if(this.tabNum===1){
                api.addOrEditEqu({
                    deviceId:this.deviceId,
                    serialCode:this.serialCode,
                    hasAdd:true,
                    name:this.$t('equipmentPair.deviceDefaultName')
                }).then((res)=>{
                    this.closeSnInput();
                    if(res.result==0){
                        this.equList=[];
                        this.page=0;
                        this.onLoadNetEqu();
                    }else {
                        Toast(res.message);
                    }
                })
            }else {
                api.addOneChild({
                    deviceId:this.deviceId,
                    serialCode:this.serialCode,
                    parentId:"",
                    hasAdd:true,
                    name:this.$t('equipmentPair.deviceDefaultName')
                }).then(res=>{
                    this.closeSnInput();
                    if(res.result==0){
                        Toast(this.$t('equipmentPair.successTip'));
                        this.terminalList=[];
                        this.tPage=0;
                        this.onLoadTerEqu();
                    }else {
                        Toast(res.message);
                    }
                })
            }
        },
        scanEqu(){
            scanQRCode(this.$t('equipmentPair.scaleQRCodeTitle'));
        },
        //扫码添加设备
        getScanningQRCode(url){
            let index = url.lastIndexOf("/");
            let str = url.substring(0,index);   //最后一个斜杠前面的值

            let deviceId = url.substring(index + 1,url.length);   //最后一个斜杠后面的值 :deviceId

            let lastIndex = str.lastIndexOf("/");
            let serialCode=str.substring(lastIndex + 1,str.length);  //:seriCode

            if(this.tabNum===1){
                api.addOrEditEqu({
                    deviceId:deviceId,
                    serialCode:serialCode,
                    hasAdd:true,
                    name:this.$t('equipmentPair.deviceDefaultName')
                }).then((res)=>{
                    if(res.result==0){
                        this.equList=[];
                        this.page=0;
                        this.onLoadNetEqu();
                        Toast(this.$t('equipmentPair.successTip'));
                    }else {
                        Toast(res.message);
                    }
                })
            }else {
                api.addOneChild({
                    deviceId:deviceId,
                    serialCode:serialCode,
                    parentId:"",
                    hasAdd:true,
                    name:this.$t('equipmentPair.deviceDefaultName')
                }).then(res=>{
                    if(res.result==0){
                        Toast(this.$t('equipmentPair.successTip'));
                        this.terminalList=[];
                        this.tPage=0;
                        this.onLoadTerEqu();
                    }else {
                        Toast(res.message);
                    }
                })
            }
        },

        //主设备删除
        delNetEqu(){
            let deviceIdStr=[];
            this.checkResult.forEach(function (n) {
                deviceIdStr.push(n.deviceId)
            });
            api.delMainEqu({
                deviceIdStr:deviceIdStr,
                isBind:false
            }).then(res=>{
                if(res.result==0){
                    Toast(this.$t('equipmentPair.successTip'));
                    this.equList=[];
                    this.page=0;
                    this.onLoadNetEqu();
                    this.cancelCheck();
                }else {
                    Toast(res.message);
                }
            })
        },

        delTerChild(){
            let deviceIdStr=[];
            this.checkTResult.forEach(function (n) {
                deviceIdStr.push(n.deviceId)
            });
            api.delChildEqu({
                deviceIdStr:deviceIdStr
            }).then(res=>{
                if(res.result==0){
                    Toast(this.$t('equipmentPair.successTip'));
                    this.terminalList=[];
                    this.tPage=0;
                    this.onLoadTerEqu();
                    this.cancelCheck();
                }else{
                    Toast(res.message);
                }
            })
        },

        //编辑设备名称
        editTerName(name,deviceId){
            this.terName=name;
            this.terDeviceId=deviceId;
            this.terNameConfirm=true;
        },
        terNameBeforeClose(action, done){
            if (action === 'confirm') {
                if(this.terName===""){
                    Toast({ message:this.$t('equipmentPair.tipEnterClientName') , duration:1000});
                    done(false);
                }else {
                    done();
                    api.addOneChild({
                        deviceId:this.terDeviceId,
                        parentId:"",
                        hasAdd:false,
                        name:this.terName
                    }).then(res=>{
                        if(res.result==0){
                            Toast(this.$t('equipmentPair.successTip'));
                            this.terNameConfirm=false;
                            this.terminalList=[];
                            this.tPage=0;
                            this.onLoadTerEqu();
                        }else {
                            Toast(res.message);
                        }
                    })
                }
            }else {
                done();
                this.terNameConfirm=false;
            }
        }
    }
}
</script>

<style scoped lang="less">
@import "../../../static/less/common";
@import "../../../static/less/equ-pair";
.equ-one-bottom{
    position: relative;
    margin-bottom: 1vh;
}
.fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
}
.fade-enter, .fade-leave-to{
    opacity: 0;
}
.pairing-text{
    .flex-center-Y;
    justify-content: center;
    color: #D62F2F;
    font-size: 12px;
    background: #FCF4F4;
    padding-bottom:20px;
}
.bind-text{
    position: absolute;
    bottom: 20px;
    left: 14.5vh;
    color: #999999;
    font-size: 12px;
}
</style>

<style>
    .sn-dialog .van-dialog__confirm, .van-dialog__confirm{
        background: #286EFF;
        color: #FFFFFF;
        border-radius: unset;
    }
    .self-dialog .van-dialog__confirm, .van-dialog__confirm{
        background: #286EFF;
        color: #FFFFFF;
        border-radius: unset;
    }
    .check .van-checkbox__icon .van-icon{
        border: 1px solid #a2a2a2;
    }
</style>
